"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var polished_1 = require("polished");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("../../../../theme/styled-components"));

var utilities_2 = require("../../../utilities");

var Common_1 = require("./Common");

var SInfo = styled_components_1["default"](Common_1.Info)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  line-height: 1.4;\n"], ["\n  ", "\n  line-height: 1.4;\n"])), polished_1.fluidRange([{
  prop: 'font-size',
  fromSize: polished_1.rem(20),
  toSize: polished_1.rem(30)
}, {
  prop: 'padding',
  fromSize: polished_1.rem(14),
  toSize: polished_1.rem(32)
}], polished_1.rem(utilities_1.mediaSizes.xxs), polished_1.rem(Common_1.MOBILE_BREAKPOINT)));
var SDescription = styled_components_1["default"](Common_1.Description)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-top: ", ";\n  font-size: ", ";\n  ", " {\n    margin-top: ", ";\n  }\n"], ["\n  margin-top: ", ";\n  font-size: ", ";\n  ", " {\n    margin-top: ", ";\n  }\n"])), polished_1.rem(8), polished_1.rem(14), utilities_1.mb(Common_1.MOBILE_BREAKPOINT), polished_1.rem(16));

var MainArticle = function (_a) {
  var article = _a.article,
      width = _a.width,
      imageAspectRatioWidth = _a.imageAspectRatioWidth,
      imageAspectRatioHeight = _a.imageAspectRatioHeight,
      className = _a.className,
      renderLink = _a.renderLink;
  return react_1["default"].createElement(Common_1.ArticleWrapper, {
    className: className,
    width: imageAspectRatioWidth,
    height: imageAspectRatioHeight
  }, renderLink({
    type: utilities_2.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
    payload: article,
    linkProps: {
      className: Common_1.linkClass,
      children: react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(Common_1.ArticlePicture, {
        picture: article.picture || {},
        naturalWidth: width,
        naturalHeight: utilities_2.calculatePictureHeight(width, imageAspectRatioWidth, imageAspectRatioHeight),
        script: "media"
      }), react_1["default"].createElement(Common_1.Overlay, null), react_1["default"].createElement(SInfo, null, react_1["default"].createElement(Common_1.Title, null, article.name), react_1["default"].createElement(SDescription, null, utilities_2.getArticleMeta(article))))
    }
  }));
};

exports["default"] = MainArticle;
var templateObject_1, templateObject_2;